import React from 'react';
import { App, Button, Col, Form, Input, Popover, Row, Space } from 'antd';
import { AxiosError } from 'axios';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import { useForm } from 'antd/lib/form/Form';
import { useMutation } from '@tanstack/react-query';

import { AreaRestritaUsuarioService, PayloadDeRecuperacaoDeSenha } from '../../../Services/Domain/AreaRestrita/UsuarioService';
import { notificarErroNaRequisicao, PropriedadesDeNotificacao } from '../../../Utils/Notificacoes';
import { ehEmail } from '../../../Utils/Formatacao';

interface IFormularioDeRecuperacaoDeSenha {
    acesso: string
}

export const PainelDeRecuperacaoDeSenha: React.FC<{
    hrefCadastro?: string,
    depoisDeFinalizar?: (valores: IFormularioDeRecuperacaoDeSenha) => any
}> = (props) => {

    const { notification } = App.useApp();
    const [formRecuperacaoDeSenha] = useForm<IFormularioDeRecuperacaoDeSenha>();

    const mutationRecuperarSenha = useMutation({
        mutationFn: (valores: IFormularioDeRecuperacaoDeSenha) => {
            let payload: PayloadDeRecuperacaoDeSenha;

            const acessandoComEmail = ehEmail(valores.acesso);
            if(acessandoComEmail){
                payload = { email: valores.acesso }
            } else {
                payload = { usuario: valores.acesso, }
            }

            return new AreaRestritaUsuarioService().recuperarSenha(payload);
        },
        onSuccess: (data, valores) => {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Verifique seu e-mail.")
            })

            props.depoisDeFinalizar?.(valores)
        },

        onError: (error: AxiosError) => {
            notificarErroNaRequisicao(error)
        }
    });

    const aoFinalizar = (valores: IFormularioDeRecuperacaoDeSenha) => {
        mutationRecuperarSenha.mutate(valores);
    }

    return (
        <div>
            <Form<IFormularioDeRecuperacaoDeSenha>
                form={formRecuperacaoDeSenha}
                layout="vertical"
                autoComplete="off"
                onFinish={aoFinalizar}
            >
                <Row gutter={16}>
                    <Col xs={24}>
                        <Form.Item<IFormularioDeRecuperacaoDeSenha>
                            label={<><Space size={"small"}> E-mail  <Popover title={<>
                                Identificador de Acesso
                                <p>Responsavel: Utilizar e-mail como identificador de Acesso</p>
                                <p>Escola: Utilizar CNPJ como identificador de Acesso</p>
                            </>}> <QuestionCircleTwoTone /> </Popover> </Space> </>}
                            name="acesso"
                            rules={[
                                { required: true, message: "Informe seu e-mail." }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row style={{ marginTop: "1em" }}>
                    <Col xs={24}>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type="primary" htmlType="submit" loading={mutationRecuperarSenha.isPending} block>Confirmar</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}